var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPackage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.17188 9.45319L14.0004 13.6869M6.17188 9.45319V18.2212L14.0004 22.4549M6.17188 9.45319L10.0862 7.49918M14.0004 13.6869V22.4549M14.0004 13.6869L17.9147 11.57M14.0004 22.4549L21.829 18.2212V9.45319M10.0862 7.49918L14.0004 5.54517L21.829 9.45319M10.0862 7.49918L17.9147 11.57M21.829 9.45319L17.9147 11.57",
    stroke: "#121217",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackage);
export default __webpack_public_path__ + "static/media/package.4876dfc38ea6b881f3f4c8f7485d43d1.svg";
export { ForwardRef as ReactComponent };